module.exports = __webpack_public_path__ + "static/img/arrow-right.85ec4d5d.svg";